import React, { useState, useEffect } from 'react';
import {ChainSorter} from 'chainsorter';

import ProcessorSummary from '../components/harvest/ProcessorSummary.js';
import Filterable from '../components/ui/filter/Filterable.js';
import Loadable from '../components/ui/loading/Loadable.js';
import api from '../api/index.js';

import './Dashboard.scss'

export default (props) => {

	const [data, setData] = useState(false);
	const [units, setUnits] = useState(false);
			
	const refresh = async () => {
		// Hit the API
		try {
			setUnits(await api.settings.get('display_units_mass'));
			let d = await api.get('harvests/processors?from=' + props.dateStart.api() + '&until=' + props.dateEnd.api());
			ChainSorter(d).desc('ProcessorName').sort();
			setData(d);
		} catch(e) {
			api.handleExceptions(e);
		};
	}


	useEffect(()=>{
		refresh();
	}, [props.dateStart, props.dateEnd])


	const filter = (data, filterstring) => {
		let filtered = [];
		const f = filterstring.toLowerCase();
		for(let i in data) {
			let summary =  data[i].ProcessorName;
			if (summary.toLowerCase().includes(f)) {
				filtered.push(data[i]);
				continue;
			}
		}
		return filtered;
	}


	return <div className="ProcessorRecords Specific">
			<h1>Processors</h1>
			<Loadable ready={data !== false} className="records">
				<Filterable 
					summaryComponent={ProcessorSummary}
					onAddSubmit={false}
					children={data}
					onSelect={false}
					type="Processors"
					filter={filter}
				/>
			</Loadable>
		</div>;
}